/*
  login
*/
/**
* Desktop/Mobile Login Management
*/


/************************************************
       RETURN URL
*************************************************/
var ru = getURLParam("ReturnUrl");
$("input[type=hidden][name=ReturnUrl]").val(ru);
